import script from "./InlineWechatBinding.vue?vue&type=script&setup=true&lang=ts"
export * from "./InlineWechatBinding.vue?vue&type=script&setup=true&lang=ts"

import "./InlineWechatBinding.vue?vue&type=style&index=0&id=04482a16&scoped=true&lang=css"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04482a16"]])

export default __exports__